import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";

const apiUrl: string = `${hostname}/aladdin_api/v1`;

const getReceiptData = (
  oauthTokenHeader: any,
  from_date: any,
  to_date: any
) => {
  return fetchWrapper.get(
    `${apiUrl}/finance/receipts/?from=${from_date}&to=${to_date}`,
    oauthTokenHeader
  );
};

const getAllCurrencies = (oauthTokenHeader: any) => {
  return fetchWrapper.get(`${apiUrl}/meta/currencies/`, oauthTokenHeader);
};

const getAllCompanies = (oauthTokenHeader: any) => {
  return fetchWrapper.get(
    `${apiUrl}/finance/receipts/companies/`,
    oauthTokenHeader
  );
};

const getPairingRate = (
  oauthTokenHeader: string,
  QUERY_ID: string,
  from_date: any,
  to_date: any,
  website_shared_uid: any
) => {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${from_date}&end_date=${to_date}&website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
};

const createReceipt = (oauthTokenHeader: string, data: any) => {
  return fetchWrapper.post(
    `${apiUrl}/finance/receipts/`,
    data,
    oauthTokenHeader
  );
};

const editReceipt = (
  oauthTokenHeader: string,
  data: any,
  receipt_shared_uid: any
) => {
  return fetchWrapper.put(
    `${apiUrl}/finance/receipts/${receipt_shared_uid}/`,
    data,
    oauthTokenHeader
  );
};
const deleteReceipt = (oauthTokenHeader: any, receipt_shared_uid: any) => {
  return fetchWrapper.delete(
    `${apiUrl}/finance/receipts/${receipt_shared_uid}/`,
    oauthTokenHeader
  );
};

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader
  );
}

function getFinancialMonthlyEarnings(
  oauthTokenHeader: any,
  company_shared_uid: any
) {
  return fetchWrapper.get(
    `${apiUrl}/finance/receipts/financial_monthly_earnings/?company_shared_uid=${company_shared_uid}`,
    oauthTokenHeader
  );
}

function createFinancialMonthlyEarnings(oauthTokenHeader: any, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/finance/receipts/link_fme/`,
    data,
    oauthTokenHeader
  );
}

function deleteFinancialMonthlyEarnings(oauthTokenHeader: any, data: any) {
  return fetchWrapper.delete(
    `${apiUrl}/finance/receipts/link_fme/`,
    data,
    oauthTokenHeader
  );
}

export const receiptServices = {
  getReceiptData,
  getAllCurrencies,
  getPairingRate,
  getAllCompanies,
  createReceipt,
  editReceipt,
  deleteReceipt,
  getAllUsers,
  getFinancialMonthlyEarnings,
  createFinancialMonthlyEarnings,
  deleteFinancialMonthlyEarnings,
};
